module.exports = __webpack_public_path__ + "static/media/visitor3.fca4d4fc.webp";